/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../ui/settings/sim-options.component';
import * as i2 from '@angular/forms';
const styles_SimOptionsComponent:any[] = ([] as any[]);
export const RenderType_SimOptionsComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_SimOptionsComponent,data:{}});
export function View_SimOptionsComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),111,'div',[['class',
      'settings-block']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n	'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          1,'h6',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['Simulation options'])),(_l()(),
          i0.ɵted((null as any),['\n\n	'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          1,'div',[['class','settings-left middle']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n		Integrator:\n	'])),
      (_l()(),i0.ɵted((null as any),['\n	'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          51,'div',[['class','settings-right middle']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          ['\n		'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),9,'label',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n			'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          6,'input',[['class','radiobutton'],['name','integrator'],['type','radio'],
              ['value','euler']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
              (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
              [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
                  (null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'change']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i1.SimOptionsComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,13)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,13).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i0.ɵnov(_v,13)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i0.ɵnov(_v,13)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('change' === en)) {
              const pd_4:any = ((<any>i0.ɵnov(_v,14).onChange()) !== false);
              ad = (pd_4 && ad);
            }
            if (('blur' === en)) {
              const pd_5:any = ((<any>i0.ɵnov(_v,14).onTouched()) !== false);
              ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_6:any = ((<any>(_co.integrator = $event)) !== false);
              ad = (pd_6 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i2.DefaultValueAccessor,
          [i0.Renderer2,i0.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i0.ɵdid(212992,(null as any),0,i2.RadioControlValueAccessor,
          [i0.Renderer2,i0.ElementRef,i2.ɵi,i0.Injector],{name:[0,'name'],value:[1,
              'value']},(null as any)),i0.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,
          (p0_0:any,p1_0:any) => {
            return [p0_0,p1_0];
          },[i2.DefaultValueAccessor,i2.RadioControlValueAccessor]),i0.ɵdid(671744,
          (null as any),0,i2.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],
              [2,i2.NG_VALUE_ACCESSOR]],{name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),
      i0.ɵprd(2048,(null as any),i2.NgControl,(null as any),[i2.NgModel]),i0.ɵdid(16384,
          (null as any),0,i2.NgControlStatus,[i2.NgControl],(null as any),(null as any)),
      (_l()(),i0.ɵted((null as any),['\n			Euler\n		'])),(_l()(),i0.ɵted((null as any),
          ['\n		'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n		'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          9,'label',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['\n			'])),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),6,'input',[['class','radiobutton'],['name','integrator'],
              ['type','radio'],['value','heunNaive']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'change']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i1.SimOptionsComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,26)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,26).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i0.ɵnov(_v,26)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i0.ɵnov(_v,26)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('change' === en)) {
              const pd_4:any = ((<any>i0.ɵnov(_v,27).onChange()) !== false);
              ad = (pd_4 && ad);
            }
            if (('blur' === en)) {
              const pd_5:any = ((<any>i0.ɵnov(_v,27).onTouched()) !== false);
              ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_6:any = ((<any>(_co.integrator = $event)) !== false);
              ad = (pd_6 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i2.DefaultValueAccessor,
          [i0.Renderer2,i0.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i0.ɵdid(212992,(null as any),0,i2.RadioControlValueAccessor,
          [i0.Renderer2,i0.ElementRef,i2.ɵi,i0.Injector],{name:[0,'name'],value:[1,
              'value']},(null as any)),i0.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,
          (p0_0:any,p1_0:any) => {
            return [p0_0,p1_0];
          },[i2.DefaultValueAccessor,i2.RadioControlValueAccessor]),i0.ɵdid(671744,
          (null as any),0,i2.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],
              [2,i2.NG_VALUE_ACCESSOR]],{name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),
      i0.ɵprd(2048,(null as any),i2.NgControl,(null as any),[i2.NgModel]),i0.ɵdid(16384,
          (null as any),0,i2.NgControlStatus,[i2.NgControl],(null as any),(null as any)),
      (_l()(),i0.ɵted((null as any),['\n			Heun (naive)\n		'])),(_l()(),i0.ɵted((null as any),
          ['\n		'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n		'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          9,'label',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['\n			'])),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),6,'input',[['class','radiobutton'],['name','integrator'],
              ['type','radio'],['value','heunStd']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'change']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i1.SimOptionsComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,39)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,39).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i0.ɵnov(_v,39)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i0.ɵnov(_v,39)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('change' === en)) {
              const pd_4:any = ((<any>i0.ɵnov(_v,40).onChange()) !== false);
              ad = (pd_4 && ad);
            }
            if (('blur' === en)) {
              const pd_5:any = ((<any>i0.ɵnov(_v,40).onTouched()) !== false);
              ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_6:any = ((<any>(_co.integrator = $event)) !== false);
              ad = (pd_6 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i2.DefaultValueAccessor,
          [i0.Renderer2,i0.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i0.ɵdid(212992,(null as any),0,i2.RadioControlValueAccessor,
          [i0.Renderer2,i0.ElementRef,i2.ɵi,i0.Injector],{name:[0,'name'],value:[1,
              'value']},(null as any)),i0.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,
          (p0_0:any,p1_0:any) => {
            return [p0_0,p1_0];
          },[i2.DefaultValueAccessor,i2.RadioControlValueAccessor]),i0.ɵdid(671744,
          (null as any),0,i2.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],
              [2,i2.NG_VALUE_ACCESSOR]],{name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),
      i0.ɵprd(2048,(null as any),i2.NgControl,(null as any),[i2.NgModel]),i0.ɵdid(16384,
          (null as any),0,i2.NgControlStatus,[i2.NgControl],(null as any),(null as any)),
      (_l()(),i0.ɵted((null as any),['\n			Heun (standard)\n		'])),(_l()(),i0.ɵted((null as any),
          ['\n		'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n		'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          9,'label',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['\n			'])),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),6,'input',[['class','radiobutton'],['name','integrator'],
              ['type','radio'],['value','heunFast']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'change']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i1.SimOptionsComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,52)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,52).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i0.ɵnov(_v,52)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i0.ɵnov(_v,52)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('change' === en)) {
              const pd_4:any = ((<any>i0.ɵnov(_v,53).onChange()) !== false);
              ad = (pd_4 && ad);
            }
            if (('blur' === en)) {
              const pd_5:any = ((<any>i0.ɵnov(_v,53).onTouched()) !== false);
              ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_6:any = ((<any>(_co.integrator = $event)) !== false);
              ad = (pd_6 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i2.DefaultValueAccessor,
          [i0.Renderer2,i0.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i0.ɵdid(212992,(null as any),0,i2.RadioControlValueAccessor,
          [i0.Renderer2,i0.ElementRef,i2.ɵi,i0.Injector],{name:[0,'name'],value:[1,
              'value']},(null as any)),i0.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,
          (p0_0:any,p1_0:any) => {
            return [p0_0,p1_0];
          },[i2.DefaultValueAccessor,i2.RadioControlValueAccessor]),i0.ɵdid(671744,
          (null as any),0,i2.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],
              [2,i2.NG_VALUE_ACCESSOR]],{name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),
      i0.ɵprd(2048,(null as any),i2.NgControl,(null as any),[i2.NgModel]),i0.ɵdid(16384,
          (null as any),0,i2.NgControlStatus,[i2.NgControl],(null as any),(null as any)),
      (_l()(),i0.ɵted((null as any),['\n			Heun (fast)\n		'])),(_l()(),i0.ɵted((null as any),
          ['\n	'])),(_l()(),i0.ɵted((null as any),['\n	'])),(_l()(),i0.ɵeld(0,(null as any),
          (null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n\n	'])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'div',[['class','settings-left']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n		Smoothing length:\n	'])),(_l()(),i0.ɵted((null as any),
          ['\n	'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),12,'div',[['class',
          'settings-right']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['\n		'])),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),1,'div',[['style','display: inline-block; width: 70px;']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['',''])),(_l()(),i0.ɵted((null as any),['\n		'])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),6,'input',[['class','slider'],
          ['max','0.1'],['min','0.001'],['step','0.001'],['title','simulation smoothing length'],
          ['type','range']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
          [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
              (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'ngModelChange'],[(null as any),'input'],[(null as any),
              'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend'],
              [(null as any),'change']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i1.SimOptionsComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,72)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,72).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i0.ɵnov(_v,72)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i0.ɵnov(_v,72)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('change' === en)) {
              const pd_4:any = ((<any>i0.ɵnov(_v,73).onChange($event.target.value)) !== false);
              ad = (pd_4 && ad);
            }
            if (('input' === en)) {
              const pd_5:any = ((<any>i0.ɵnov(_v,73).onChange($event.target.value)) !== false);
              ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
              const pd_6:any = ((<any>i0.ɵnov(_v,73).onTouched()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.smoothingLength = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i2.DefaultValueAccessor,
          [i0.Renderer2,i0.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i0.ɵdid(16384,(null as any),0,i2.ɵbe,[i0.Renderer2,i0.ElementRef],
          (null as any),(null as any)),i0.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,
          (p0_0:any,p1_0:any) => {
            return [p0_0,p1_0];
          },[i2.DefaultValueAccessor,i2.ɵbe]),i0.ɵdid(671744,(null as any),0,i2.NgModel,
          [[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i2.NgControl,(null as any),[i2.NgModel]),i0.ɵdid(16384,(null as any),0,i2.NgControlStatus,
          [i2.NgControl],(null as any),(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n	'])),(_l()(),i0.ɵted((null as any),['\n	'])),(_l()(),i0.ɵeld(0,(null as any),
          (null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n\n\n	'])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'div',[['class','settings-left middle']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n		Boundary:\n	'])),(_l()(),i0.ɵted((null as any),
          ['\n	'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),25,'div',[['class',
          'settings-right middle']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['\n		'])),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),9,'label',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          ['\n			'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),6,'input',[['class',
          'radiobutton'],['name','boundary'],['type','radio'],['value','cyclic']],
          [[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
              'ngModelChange'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
              'compositionstart'],[(null as any),'compositionend'],[(null as any),
              'change']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i1.SimOptionsComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,90)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,90).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i0.ɵnov(_v,90)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i0.ɵnov(_v,90)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('change' === en)) {
              const pd_4:any = ((<any>i0.ɵnov(_v,91).onChange()) !== false);
              ad = (pd_4 && ad);
            }
            if (('blur' === en)) {
              const pd_5:any = ((<any>i0.ɵnov(_v,91).onTouched()) !== false);
              ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_6:any = ((<any>(_co.boundary = $event)) !== false);
              ad = (pd_6 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i2.DefaultValueAccessor,
          [i0.Renderer2,i0.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i0.ɵdid(212992,(null as any),0,i2.RadioControlValueAccessor,
          [i0.Renderer2,i0.ElementRef,i2.ɵi,i0.Injector],{name:[0,'name'],value:[1,
              'value']},(null as any)),i0.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,
          (p0_0:any,p1_0:any) => {
            return [p0_0,p1_0];
          },[i2.DefaultValueAccessor,i2.RadioControlValueAccessor]),i0.ɵdid(671744,
          (null as any),0,i2.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],
              [2,i2.NG_VALUE_ACCESSOR]],{name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),
      i0.ɵprd(2048,(null as any),i2.NgControl,(null as any),[i2.NgModel]),i0.ɵdid(16384,
          (null as any),0,i2.NgControlStatus,[i2.NgControl],(null as any),(null as any)),
      (_l()(),i0.ɵted((null as any),['\n			Cyclic\n		'])),(_l()(),i0.ɵted((null as any),
          ['\n		'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n		'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          9,'label',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['\n			'])),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),6,'input',[['class','radiobutton'],['name','boundary'],
              ['type','radio'],['value','solid']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'change']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i1.SimOptionsComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,103)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,103).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i0.ɵnov(_v,103)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i0.ɵnov(_v,103)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('change' === en)) {
              const pd_4:any = ((<any>i0.ɵnov(_v,104).onChange()) !== false);
              ad = (pd_4 && ad);
            }
            if (('blur' === en)) {
              const pd_5:any = ((<any>i0.ɵnov(_v,104).onTouched()) !== false);
              ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_6:any = ((<any>(_co.boundary = $event)) !== false);
              ad = (pd_6 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i2.DefaultValueAccessor,
          [i0.Renderer2,i0.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i0.ɵdid(212992,(null as any),0,i2.RadioControlValueAccessor,
          [i0.Renderer2,i0.ElementRef,i2.ɵi,i0.Injector],{name:[0,'name'],value:[1,
              'value']},(null as any)),i0.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,
          (p0_0:any,p1_0:any) => {
            return [p0_0,p1_0];
          },[i2.DefaultValueAccessor,i2.RadioControlValueAccessor]),i0.ɵdid(671744,
          (null as any),0,i2.NgModel,[[8,(null as any)],[8,(null as any)],[8,(null as any)],
              [2,i2.NG_VALUE_ACCESSOR]],{name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),
      i0.ɵprd(2048,(null as any),i2.NgControl,(null as any),[i2.NgModel]),i0.ɵdid(16384,
          (null as any),0,i2.NgControlStatus,[i2.NgControl],(null as any),(null as any)),
      (_l()(),i0.ɵted((null as any),['\n			Solid\n		'])),(_l()(),i0.ɵted((null as any),
          ['\n	'])),(_l()(),i0.ɵted((null as any),['\n\n'])),(_l()(),i0.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    var _co:i1.SimOptionsComponent = _v.component;
    const currVal_7:any = 'integrator';
    const currVal_8:any = 'euler';
    _ck(_v,14,0,currVal_7,currVal_8);
    const currVal_9:any = 'integrator';
    const currVal_10:any = _co.integrator;
    _ck(_v,16,0,currVal_9,currVal_10);
    const currVal_18:any = 'integrator';
    const currVal_19:any = 'heunNaive';
    _ck(_v,27,0,currVal_18,currVal_19);
    const currVal_20:any = 'integrator';
    const currVal_21:any = _co.integrator;
    _ck(_v,29,0,currVal_20,currVal_21);
    const currVal_29:any = 'integrator';
    const currVal_30:any = 'heunStd';
    _ck(_v,40,0,currVal_29,currVal_30);
    const currVal_31:any = 'integrator';
    const currVal_32:any = _co.integrator;
    _ck(_v,42,0,currVal_31,currVal_32);
    const currVal_40:any = 'integrator';
    const currVal_41:any = 'heunFast';
    _ck(_v,53,0,currVal_40,currVal_41);
    const currVal_42:any = 'integrator';
    const currVal_43:any = _co.integrator;
    _ck(_v,55,0,currVal_42,currVal_43);
    const currVal_52:any = _co.smoothingLength;
    _ck(_v,75,0,currVal_52);
    const currVal_60:any = 'boundary';
    const currVal_61:any = 'cyclic';
    _ck(_v,91,0,currVal_60,currVal_61);
    const currVal_62:any = 'boundary';
    const currVal_63:any = _co.boundary;
    _ck(_v,93,0,currVal_62,currVal_63);
    const currVal_71:any = 'boundary';
    const currVal_72:any = 'solid';
    _ck(_v,104,0,currVal_71,currVal_72);
    const currVal_73:any = 'boundary';
    const currVal_74:any = _co.boundary;
    _ck(_v,106,0,currVal_73,currVal_74);
  },(_ck,_v) => {
    var _co:i1.SimOptionsComponent = _v.component;
    const currVal_0:any = i0.ɵnov(_v,18).ngClassUntouched;
    const currVal_1:any = i0.ɵnov(_v,18).ngClassTouched;
    const currVal_2:any = i0.ɵnov(_v,18).ngClassPristine;
    const currVal_3:any = i0.ɵnov(_v,18).ngClassDirty;
    const currVal_4:any = i0.ɵnov(_v,18).ngClassValid;
    const currVal_5:any = i0.ɵnov(_v,18).ngClassInvalid;
    const currVal_6:any = i0.ɵnov(_v,18).ngClassPending;
    _ck(_v,12,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_11:any = i0.ɵnov(_v,31).ngClassUntouched;
    const currVal_12:any = i0.ɵnov(_v,31).ngClassTouched;
    const currVal_13:any = i0.ɵnov(_v,31).ngClassPristine;
    const currVal_14:any = i0.ɵnov(_v,31).ngClassDirty;
    const currVal_15:any = i0.ɵnov(_v,31).ngClassValid;
    const currVal_16:any = i0.ɵnov(_v,31).ngClassInvalid;
    const currVal_17:any = i0.ɵnov(_v,31).ngClassPending;
    _ck(_v,25,0,currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,
        currVal_17);
    const currVal_22:any = i0.ɵnov(_v,44).ngClassUntouched;
    const currVal_23:any = i0.ɵnov(_v,44).ngClassTouched;
    const currVal_24:any = i0.ɵnov(_v,44).ngClassPristine;
    const currVal_25:any = i0.ɵnov(_v,44).ngClassDirty;
    const currVal_26:any = i0.ɵnov(_v,44).ngClassValid;
    const currVal_27:any = i0.ɵnov(_v,44).ngClassInvalid;
    const currVal_28:any = i0.ɵnov(_v,44).ngClassPending;
    _ck(_v,38,0,currVal_22,currVal_23,currVal_24,currVal_25,currVal_26,currVal_27,
        currVal_28);
    const currVal_33:any = i0.ɵnov(_v,57).ngClassUntouched;
    const currVal_34:any = i0.ɵnov(_v,57).ngClassTouched;
    const currVal_35:any = i0.ɵnov(_v,57).ngClassPristine;
    const currVal_36:any = i0.ɵnov(_v,57).ngClassDirty;
    const currVal_37:any = i0.ɵnov(_v,57).ngClassValid;
    const currVal_38:any = i0.ɵnov(_v,57).ngClassInvalid;
    const currVal_39:any = i0.ɵnov(_v,57).ngClassPending;
    _ck(_v,51,0,currVal_33,currVal_34,currVal_35,currVal_36,currVal_37,currVal_38,
        currVal_39);
    const currVal_44:any = _co.smoothingLength;
    _ck(_v,69,0,currVal_44);
    const currVal_45:any = i0.ɵnov(_v,77).ngClassUntouched;
    const currVal_46:any = i0.ɵnov(_v,77).ngClassTouched;
    const currVal_47:any = i0.ɵnov(_v,77).ngClassPristine;
    const currVal_48:any = i0.ɵnov(_v,77).ngClassDirty;
    const currVal_49:any = i0.ɵnov(_v,77).ngClassValid;
    const currVal_50:any = i0.ɵnov(_v,77).ngClassInvalid;
    const currVal_51:any = i0.ɵnov(_v,77).ngClassPending;
    _ck(_v,71,0,currVal_45,currVal_46,currVal_47,currVal_48,currVal_49,currVal_50,
        currVal_51);
    const currVal_53:any = i0.ɵnov(_v,95).ngClassUntouched;
    const currVal_54:any = i0.ɵnov(_v,95).ngClassTouched;
    const currVal_55:any = i0.ɵnov(_v,95).ngClassPristine;
    const currVal_56:any = i0.ɵnov(_v,95).ngClassDirty;
    const currVal_57:any = i0.ɵnov(_v,95).ngClassValid;
    const currVal_58:any = i0.ɵnov(_v,95).ngClassInvalid;
    const currVal_59:any = i0.ɵnov(_v,95).ngClassPending;
    _ck(_v,89,0,currVal_53,currVal_54,currVal_55,currVal_56,currVal_57,currVal_58,
        currVal_59);
    const currVal_64:any = i0.ɵnov(_v,108).ngClassUntouched;
    const currVal_65:any = i0.ɵnov(_v,108).ngClassTouched;
    const currVal_66:any = i0.ɵnov(_v,108).ngClassPristine;
    const currVal_67:any = i0.ɵnov(_v,108).ngClassDirty;
    const currVal_68:any = i0.ɵnov(_v,108).ngClassValid;
    const currVal_69:any = i0.ɵnov(_v,108).ngClassInvalid;
    const currVal_70:any = i0.ɵnov(_v,108).ngClassPending;
    _ck(_v,102,0,currVal_64,currVal_65,currVal_66,currVal_67,currVal_68,currVal_69,
        currVal_70);
  });
}
export function View_SimOptionsComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'websph-settings-sim-settings',
      ([] as any[]),(null as any),(null as any),(null as any),View_SimOptionsComponent_0,
      RenderType_SimOptionsComponent)),i0.ɵdid(49152,(null as any),0,i1.SimOptionsComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const SimOptionsComponentNgFactory:i0.ComponentFactory<i1.SimOptionsComponent> = i0.ɵccf('websph-settings-sim-settings',
    i1.SimOptionsComponent,View_SimOptionsComponent_Host_0,{},{integratorNotify:'integratorNotify',
        smoothingLengthNotify:'smoothingLengthNotify',boundaryNotify:'boundaryNotify'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// D:/[Projects]/WebSPH.gits/WebSPH.git/src/$$_gendir/ui/settings/sim-options.component.ngfactory.ts